import { render, staticRenderFns } from "./DateRangeSelector.vue?vue&type=template&id=5882c5b6&scoped=true"
import script from "./DateRangeSelector.vue?vue&type=script&lang=js"
export * from "./DateRangeSelector.vue?vue&type=script&lang=js"
import style0 from "./DateRangeSelector.vue?vue&type=style&index=0&id=5882c5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5882c5b6",
  null
  
)

export default component.exports